import React from 'react';
import PropTypes from 'prop-types';

const FormatPercentV2Renderer = (props) => {
  const value = props.value;
    return <span>{value > 0 ? `${value}%` : null}</span>
}

FormatPercentV2Renderer.propTypes = {
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default FormatPercentV2Renderer;
